import styled, { css } from 'styled-components'
import { Devices, Spacings, Text } from '@styles'
import { H4 } from '@base'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: ${Spacings.SPACING_2B};

	@media ${Devices.tablet} {
		padding: 0;
	}
	@media ${Devices.laptop} {
		flex-direction: row;
		flex-wrap: wrap;
		${({ showSideMenu }) => {
			if (!showSideMenu) {
				return css`
					flex-direction: row;
				`
			}
		}}
	}
	${({ fullWidth }) => {
		if (fullWidth) {
			return css`
				@media ${Devices.laptop} {
					flex-direction: column;
					width: 100%;
					flex-wrap: nowrap;
				}
			`
		}
	}}
`

export const ItemWrapper = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	border-radius: ${Spacings.SPACING_2B};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	flex-grow: 1;
	margin-bottom: ${Spacings.SPACING_4B};
	display: flex;
	flex-direction: column;
	padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_2B};
	min-height: 22rem;
	max-height: 25rem;
	width: 100%;

	& .recharts-default-legend {
		font-size: ${Text.SMALL};
		& > li {
			display: inline-flex;
			align-items: center;
		}
	}

	${({ fullWidth }) => {
		if (!fullWidth) {
			return css`
				@media ${Devices.mobile} {
					flex: 1;
				}
				@media ${Devices.laptop} {
					flex-basis: calc(50% - ${Spacings.SPACING_4B});
					max-width: calc(50% - ${Spacings.SPACING_2B});
					flex-grow: 1;
					&:nth-child(2n + 1) {
						margin-right: ${Spacings.SPACING_4B};
					}
					${({ showSideMenu }) => {
						if (!showSideMenu) {
							return css`
								flex-basis: calc(100% - ${Spacings.SPACING_4B});
								max-width: calc(100% - ${Spacings.SPACING_2B});
							`
						}
					}}
				}
			`
		}
	}}
	${({ fullHight }) => {
		if (fullHight) {
			return css`
				@media ${Devices.laptop} {
					flex-basis: calc(50% - ${Spacings.SPACING_4B});
					max-width: calc(100% - ${Spacings.SPACING_2B});
				}
			`
		}
	}}
`

export const ItemHeader = styled(H4)`
	margin: 0 ${Spacings.SPACING_2B} ${Spacings.SPACING_4B} ${Spacings.SPACING_2B};
	color: ${({ theme }) => theme.palette.text.black};
	padding-bottom: ${Spacings.SPACING_3B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
`

export const AccumulatedDataWrapper = styled.div``

export const LoaderWrapper = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	border-radius: ${Spacings.SPACING_2B};
	padding: ${Spacings.SPACING_4B};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	flex-grow: 1;
	display: flex;
	align-items: center;
	margin-bottom: ${Spacings.SPACING_4B};
	justify-content: center;
`
